export default __webpack_public_path__ + "static/media/logo-11-2022.2f0afbdd.png";